export default __webpack_public_path__ + "static/media/refer-hero.f06ffff1.png";